// ** React Imports
import { useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { setLanguageAsync } from "store/modules/global-common.slice";

// ** Custom Components
import Text from "components/typography/Text";
import LinkNative from "./LinkNative";
import CommaList from "./CommaList";

// ** Utils & Helpers
import { LANG } from "helpers/constants";
import { generateLanguageSubdomainUrl } from "helpers/languageSubdomainHandler";

// #####################################################

const LangSelectorSeo = () => {
	const dispatch = useDispatch();
	const location = useLocation();
	const currentLanguage = useSelector((state) => state.globalCommon.language);

	// #####################################################

	return (
		<CommaList>
			{LANG.map((item, index) => {
				const languageUrl = generateLanguageSubdomainUrl(
					item.value,
					location.pathname,
					location.search,
					location.hash,
				);

				const isCurrentLanguage = item.value === currentLanguage;

				return (
					<span
						key={`lang-selector-seo-${item.value}`}
						style={{
							cursor: "pointer",
						}}
					>
						<LinkNative
							href={languageUrl}
							target="_self"
							color={"primary"}
							noColorVisited
							underline
							style={{
								fontWeight: isCurrentLanguage
									? "bold"
									: "normal",
							}}
							onClick={() => {
								dispatch(
									setLanguageAsync({
										language: item.value,
										setCookie: true,
										withRedirect: false,
									}),
								);
							}}
						>
							{item.langName}
							{index !== LANG.length - 1 && <Text mr={1}>,</Text>}
						</LinkNative>
					</span>
				);
			})}
		</CommaList>
	);
};

// #####################################################

export default LangSelectorSeo;

// #####################################################
